import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'layout',
      meta: {
        requiresAuth: false
      },
      component: () => import('./views/Layout.vue'),
      children: [
        {
          path: '/',
          name: 'home',
          component: () => import('./views/Home.vue')
        },
        // {
        //   path: '/getstart',
        //   name: 'getstart',
        //   component: () => import('./views/Getstarted.vue')
        // },
        {
          path: '/demo/address',
          name: 'demo-address',
          component: () => import('./views/Address.vue')
        },
        {
          path: '/demo/email',
          name: 'demo-email',
          component: () => import('./views/Email.vue')
        },
        {
          path: '/demo/country',
          name: 'demo-country',
          component: () => import('./views/Country.vue')
        },
        {
          path: '/demo/tokenize',
          name: 'demo-tokenize',
          component: () => import('./views/Tokenize.vue')
        },
        {
          path: '/demo/similar',
          name: 'demo-similar',
          component: () => import('./views/Similar.vue')
        },
        {
          path: '/demo/ocr',
          name: 'demo-ocr',
          component: () => import('./views/OCR.vue')
        },
        {
          path: '/demo/license-plate',
          name: 'demo-license-plate',
          component: () => import('./views/LicensePlate.vue')
        },
        {
          path: '/demo/sentiment',
          name: 'demo-sentiment',
          component: () => import('./views/Sentiment.vue')
        },
        {
          path: '/demo/cleansing',
          name: 'demo-cleansing',
          component: () => import('./views/Cleansing.vue')
        },
        {
          path: '/demo/spell',
          name: 'demo-spell',
          component: () => import('./views/Spell.vue')
        },
        {
          path: '/demo/datetime',
          name: 'demo-datetime',
          component: () => import('./views/Datetime.vue')
        },
        {
          path: '/demo/clustering',
          name: 'demo-clustering',
          component: () => import('./views/Clustering.vue')
        },
        {
          path: '/demo/classification',
          name: 'demo-classification',
          component: () => import('./views/Classification.vue')
        }
      ]
    }
    // {
    //   path: '/getstarted',
    //   name: 'get-started',
    //   component: () => import('./views/Getstarted.vue')
    // }
  ]
})

router.afterEach((to, from) => {
  // TODO Reconsider this condition again
  if (from.name) {
    // window.onePalette.emitEvent('routing', {
    //   action: 'routing',
    //   target: null,
    //   linkTo: to.name,
    //   label: 'demo',
    //   value: null,
    //   amount: null
    // })
  }
})

export default router
